import { render, staticRenderFns } from "./SnTable.vue?vue&type=template&id=fd60766a&scoped=true"
import script from "./SnTable.vue?vue&type=script&lang=js"
export * from "./SnTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd60766a",
  null
  
)

export default component.exports